import React from "react";
import styles from "./Layout.module.scss";
import { Outlet } from "react-router-dom";

// Components
import Topbar from "components/Shared/Topbar";

const layout = () => {
  return (
    <div className={styles.Layout}>
      <Topbar />
      <Outlet />
    </div>
  );
};

export default layout;
